import { createAction } from '@reduxjs/toolkit'

const setMaxShownItemsCount = createAction<number>('@@pagination/SET_MAX_SHOWN_ITEMS_COUNT')

const clearMaxShownItemsCount = createAction('@@pagination/CLEAR_MAX_SHOWN_ITEMS_COUNT')

export { setMaxShownItemsCount, clearMaxShownItemsCount }
